/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

/** @param {Question} question */
export const validateContent = (question) => {
    if (!question?.content) {
        return [`Question ${question?.type} requires content`];
    }
    return [];
};
